<template>
    <form
        :action="route('cart.delivery.store')"
        :class="{ 'prevent-clicks': isLoading }"
        method="post"
    >
        <input type="hidden" name="_token" :value="csrfToken">

        <div
            v-for="(shipping, index) in shippingProviders"
            :key="index"
            class="form-group"
        >
            <h4 v-if="index === 1 && shipping.method === 'pickup'">
                {{ $t('checkout.delivery_pickup') }}
            </h4>

            <div class="form-check form-check-payment">
                <input
                    @change="shippingChange(shipping.id)"
                    :id="`shipping-${index}`"
                    :checked="index === 0"
                    :value="shipping.id"
                    class="form-check-input"
                    type="radio"
                    name="shipping"
                >
                <label
                    class="form-check-label"
                    :for="`shipping-${index}`"
                >
                    <span
                        v-html="shipping.title"
                        class="form-check-label-title"
                    />
                    <span class="form-check-label-action price">
                        <template v-if="shipping.price.inc > 0">
                            {{ shipping.price.inc | currency }}
                        </template>
                        <template v-else>
                            {{ $t('checkout.free') }}
                        </template>
                    </span>
                </label>
            </div>

            <a
                v-if="index === 0 && shipping.method === 'deliver'"
                :href="route('cart.checkout')"
                class="d-block mt-2 mb-4"
            >
                {{ $t('checkout.delivery_change_address') }}
            </a>
        </div>

        <button class="btn btn-primary">
            {{ $t('checkout.to_payment') }}
        </button>
    </form>
</template>

<script>
    import axios from 'axios';
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'CheckoutShipping',
        data() {
            return {
                shippingProviders: [],
            };
        },
        created() {
            this.getShippingProviders();
        },
        computed: {
            ...mapState('basket', {
                isLoading: 'isLoading',
            }),
        },
        methods: {
            ...mapActions('basket', [
                'fetchBasket',
            ]),

            async getShippingProviders() {
                const { data } = await axios.get('/shipping-options/json');

                this.shippingProviders = data.shipping_providers;
            },

            async shippingChange(id) {
                await axios.post(this.route('cart.shipping-option.update'), {
                    shippingId: id,
                });

                this.fetchBasket();
            },
        },
    };
</script>
